<div class="vstack gap-1">
  <mat-form-field>
    <mat-label>{{ label || findLabel }}</mat-label>
    <input
      matInput
      [formControl]="addressControl"
      autocomplete="off"
      [matAutocomplete]="auto"
      [placeholder]="placeholder"
    />
    <mat-autocomplete #auto [displayWith]="displayWith">
      <ng-container *ngIf="addressOptions$ | async as addressOptions">
        <mat-option *ngFor="let option of addressOptions" [value]="option">
          {{ option.Text }}
        </mat-option>
        <mat-option disabled *ngIf="!addressOptions.length" i18n>
          No matching results
        </mat-option>
      </ng-container>
    </mat-autocomplete>
    <mat-error>{{ findErrorMessage }}</mat-error>
  </mat-form-field>

  <ng-container *ngIf="firstLineOptions$ | async as addressOptions">
    <mat-form-field *ngIf="addressOptions.length">
      <mat-label>{{ retrieveLabel }}</mat-label>
      <mat-select
        (selectionChange)="_firstLineSelectedSubject.next($event)"
        [formControl]="firstLineControl"
      >
        <ng-container>
          <mat-option *ngFor="let option of addressOptions" [value]="option">
            {{ option.Text }}
          </mat-option>
          <mat-option disabled *ngIf="!addressOptions.length" i18n>
            No matching results
          </mat-option>
        </ng-container>
      </mat-select>
      <mat-error>{{ retrieveErrorMessage }}</mat-error>
    </mat-form-field>
  </ng-container>
</div>
